export const addStringInBetween = (str: string, step: number, replace: string) => {
  return str.replace(
    new RegExp(`([0-9]{1,${step}})`, 'ig'),
    (v, _, offset) => `${offset ? replace : ''}${v}`
  );
};
